import React, { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";
import { fetchBlog } from "../lib/api";
import { langField } from "../lib/i18n";

export default function Blog() {
  const { t, lang } = useApp();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetchBlog().then(setPosts);
  }, []);

  return (
    <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-12 md:py-20" data-testid="page-blog">
      <p className="font-mono text-xs tracking-[0.3em] text-kult-yellow">/ JOURNAL</p>
      <h1 className="font-display text-6xl md:text-8xl mt-2 mb-3 leading-none">
        {t.blog.title}
      </h1>
      <p className="text-kult-muted max-w-xl mb-10">{t.blog.sub}</p>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6" data-testid="blog-grid">
        {posts.map((p, i) => (
          <article
            key={p.id}
            className={`group border border-kult-border bg-kult-black2 hover:border-kult-pink transition-colors ${
              i === 0 ? "md:col-span-12" : "md:col-span-6"
            }`}
            data-testid={`blog-post-${p.slug}`}
          >
            <div
              className={`overflow-hidden ${
                i === 0 ? "aspect-[21/9]" : "aspect-[16/10]"
              } bg-black`}
            >
              <img
                src={p.image}
                alt={p.title}
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-6">
              <div className="flex items-center gap-3 mb-3">
                <span className="font-mono text-[10px] tracking-[0.3em] bg-kult-yellow text-black px-2 py-0.5">
                  {p.tag}
                </span>
                <span className="font-mono text-[10px] tracking-[0.25em] text-kult-muted">
                  {p.date} · {p.author}
                </span>
              </div>
              <h3
                className={`font-display leading-tight group-hover:text-kult-pink transition-colors ${
                  i === 0 ? "text-4xl md:text-6xl" : "text-2xl md:text-3xl"
                }`}
              >
                {langField(p, "title", lang)}
              </h3>
              <p className="text-kult-muted mt-3">{langField(p, "excerpt", lang)}</p>
              <span className="inline-block mt-4 font-mono text-xs tracking-[0.25em] kult-link">
                {t.blog.read} →
              </span>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
